import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthWrapper } from "../layouts/index";
import { useAuth } from "../hooks/index";

export const SpecialRoute = () => {
  const {
    loggedUser: { user },
  } = useAuth();
  const location = useLocation();

  // Don't wrap login page with AuthWrapper
  if (location.pathname === '/login') {
    return !user ? <Outlet /> : <Navigate to="/" />;
  }

  return !user ? (
    <AuthWrapper>
      <Outlet />
    </AuthWrapper>
  ) : (
    <Navigate to="/" />
  );
};
